module.exports = __webpack_public_path__ + "img/jjwxc.0ebe928a.svg";